import React from 'react';
import '../Landing.css';
import {
  Grid,
  List,
  ListItem,
  ListItemText,
  Divider,
  ListItemIcon,
  Typography,
  ListSubheader,
} from '@material-ui/core';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import headersSection from '../headersStyle';
import testimonialsSection from '../testimonialsStyle';
import PlusIcon from '../../../../assets/icons/ReactSvg/PlusIcon';
import Clerk from '../../../../assets/icons/ReactSvg/Clerk';
import UserSvg from '../../../../assets/icons/ReactSvg/UserSvg';

const hexToRgb = (input) => {
  input = input + '';
  input = input.replace('#', '');
  let hexRegex = /[0-9A-Fa-f]/g;
  if (!hexRegex.test(input) || (input.length !== 3 && input.length !== 6)) {
    throw new Error('input is not a valid hex color.');
  }
  if (input.length === 3) {
    let first = input[0];
    let second = input[1];
    let last = input[2];
    input = first + first + second + second + last + last;
  }
  input = input.toUpperCase(input);
  let first = input[0] + input[1];
  let second = input[2] + input[3];
  let last = input[4] + input[5];
  return parseInt(first, 16) + ', ' + parseInt(second, 16) + ', ' + parseInt(last, 16);
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
  },
  media: {
    height: 140,
  },
  mediaHeader: {
    height: 240,
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightBold,
  },
  headingNormal: {
    fontSize: theme.typography.pxToRem(16),
    fontWeight: theme.typography.fontWeightRegular,
  },
  ...testimonialsSection,
  pageHeader: {
    position: 'relative',
    height: '100vh',
    maxHeight: '1600px',
    backgroundPosition: '50%',
    backgroundSize: 'cover',
    margin: '0',
    padding: '0',
    border: '0',
    display: 'flex',
    WebkitBoxAlign: 'center',
    MsFlexAlign: 'center',
    alignItems: 'center',
    '&:before': {
      background: 'rgba(' + hexToRgb('#000') + ', 0.5)',
    },
    '&:after,&:before': {
      position: 'absolute',
      zIndex: '1',
      width: '100%',
      height: '100%',
      display: 'block',
      left: '0',
      top: '0',
      content: "''",
    },
  },
  icon: {
    float: 'none',
    // marginTop: "24px",
    marginLeft: 'auto',
    marginRight: 'auto',
    width: '61px',
    height: '61px',
    marginBottom: '24px',
  },
}));

const Advantages = (props) => {
  const { classes } = props;
  const expClasses = useStyles();
  return (
    <Grid container spacing={3} justify="center" id="advantages">
      <Grid item xs={12} sm={12} md={10} className={`${classes.mlAuto} ${classes.mrAuto} ${classes.textCenter}`}>
        <h2 className={classes.title}>
          Переваги та можливості
          <br /> програмного комплексу «Інтегрована інформаційна система
          <br /> «Соціальна громада»:
        </h2>
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <div className={expClasses.icon}>
          <Clerk />
        </div>
        <h5 className="text-center font-weight-bold">Для посадових осіб органів місцевого самоврядування</h5>
        <List>
          <ListItem>
            <ListItemIcon>
              <PlusIcon />
            </ListItemIcon>
            <ListItemText secondary="Уніфікація форматів ділових процесів та оптимізація роботи користувачів, що забезпечується використанням особистих кабінетів на кожному рівні." />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemIcon>
              <PlusIcon />
            </ListItemIcon>
            <ListItemText secondary="Об’єднання актуальних та узгоджених даних із усіх ТГ в єдиному інформаційному середовищі." />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemIcon>
              <PlusIcon />
            </ListItemIcon>
            <ListItemText secondary="Зменшення помилок в процесі формування даних, оскільки реквізити електронних заяв формуються з використанням централізованої нормативно- довідкової інформації (далі - НДІ). Персональні дані заявника (адреса реєстрації, фактичного місця проживання та інформація про членів родини) формуються з централізованих баз даних  отримувачів усіх видів соціальної допомоги та компенсаційних виплат." />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemIcon>
              <PlusIcon />
            </ListItemIcon>
            <ListItemText secondary="Оперативне надходження до СПСЗН (в кінці робочого дня) електронних заяв з «прикріпленими» сканованими копіями документів, прискорить процес призначення (перерахунку) соціальної допомоги та компенсаційних виплат." />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemIcon>
              <PlusIcon />
            </ListItemIcon>
            <ListItemText secondary="Інтеграція з діючими програмними комплексами - АСОПД/КОМТЕХ-СОЦ, ЄДАРП, Житлові субсидії." />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemIcon>
              <PlusIcon />
            </ListItemIcon>
            <ListItemText secondary="Отримані електронні заяви опрацьовуються спеціалістами СПСЗН, після опрацювання, в ТГ передається повідомлення про призначення (відмову) допомоги із зазначенням її розміру та терміном дії." />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemIcon>
              <PlusIcon />
            </ListItemIcon>
            <ListItemText secondary="Гнучкість ПК «ІІС «Соціальна громада» дозволяє швидко змінювати ролі, права та функції користувачів системи, на нові з додатковими функціями." />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemIcon>
              <PlusIcon />
            </ListItemIcon>
            <ListItemText secondary="Швидке реагування на постійні зміни в законодавстві." />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemIcon>
              <PlusIcon />
            </ListItemIcon>
            <ListItemText secondary="Формування електронного «журналу реєстрації звернень» дозволяє керівнику ТГ та спеціалістам СПСЗН виконувати моніторинг опрацювання заяв та здійснювати швидкий пошук звернень за будь-якою ознакою (до прикладу, заяви з повним або неповним пакетом документів, станом опрацювання заяви, видом допомог, статусом заяви тощо)." />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemIcon>
              <PlusIcon />
            </ListItemIcon>
            <ListItemText secondary="Підсистема «Звітність» надає можливість формувати Звіт про кількість прийнятих та опрацьованих заяв в ТГ." />
          </ListItem>
          <div style={{ paddingLeft: '6%' }}>
            <List
              aria-labelledby="nested-list-subheader"
              subheader={
                <ListSubheader component="div" id="nested-list-subheader" disableSticky>
                  Планується формування заяв:
                </ListSubheader>
              }
            >
              <ListItemText secondary="«Пакунок малюка»" />
              <ListItemText secondary="«Муніципальна няня»" />
              <ListItemText secondary="«Для ВПО про взяття на облік»" />
              <ListItemText secondary="«Для ВПО на призначення допомоги»" />
              <ListItemText secondary="«Про надання пільг з оплати ЖКХ у грошовій готівковій формі»" />
              <ListItemText secondary="«Видачу посвідчення батькам багатодітної сім’ї»" />
              <ListItemText secondary="«ЦБІ»" />
            </List>
          </div>
        </List>
      </Grid>
      <Grid item xs={12} sm={12} md={12}>
        <div className={expClasses.icon}>
          <UserSvg />
        </div>
        <h5 className="text-center font-weight-bold">Для населення:</h5>

        <List>
          <ListItem>
            <ListItemIcon>
              <PlusIcon />
            </ListItemIcon>
            <ListItemText secondary="Можливість оформити та отримати адміністративну послугу соціального характеру ближче до місця проживання, а не їхати за нею до СПСЗН – у районний центр." />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemIcon>
              <PlusIcon />
            </ListItemIcon>
            <ListItemText secondary="Пришвидшення процесу прийому заяв від громадян шляхом формування електронних заяв, як для призначення усіх видів соціальних допомог та компенсаційних виплат, так і для взяття пільговика на облік, призначення житлової субсидії. Електронна заява друкується та підписується заявником." />
          </ListItem>
          <Divider />
          <ListItem>
            <ListItemIcon>
              <PlusIcon />
            </ListItemIcon>
            <ListItemText secondary="Можливість відстеження стану розгляду заяв після звернення до «фронт»-офісу." />
          </ListItem>
        </List>
      </Grid>
    </Grid>
  );
};

export default withStyles(headersSection)(Advantages);
